import React from "react";

import Tree from "../../../../../Machines/components/Tree";

const Assets = ({ user }) => {
  return <Tree target={"_blank"} assets={user.assets || []} />;
};

export default Assets;
